export const TAIWAN_VIEW_BOUNDS = {
  north: 26.62781822639305,
  south: 20.673905264672843,
  east: 124.8046875,
  west: 116.5869140625,
};

export const TAIWAN_CENTER_POINT = {
  lat: 23.8054711,
  lng: 121.1826734,
};

export const DEFAULT_OPTIONS: google.maps.MapOptions = {
  center: TAIWAN_CENTER_POINT,
  restriction: {
    latLngBounds: TAIWAN_VIEW_BOUNDS,
  },
  zoom: 8,
  minZoom: 6,
  controlSize: 30,
  mapTypeControl: false,
  streetViewControl: false,
};

export const ICON_PATH = {
  Place:
    "M12 2c-4.2 0-8 3.22-8 8.2c0 3.18 2.45 6.92 7.34 11.23c.38.33.95.33 1.33 0C17.55 17.12 20 13.38 20 10.2C20 5.22 16.2 2 12 2zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2z",
  Origin: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2z",
};

export const GOOGLE_MAP_ICONS = {
  Place: {
    path: ICON_PATH.Place,
    anchor: { x: 12, y: 22 },
    fillColor: "#D13F2C",
    fillOpacity: 1,
    strokeColor: "#992314",
    strokeOpacity: 1,
    scale: 1.3,
  } as google.maps.Symbol,
  PlaceOrigin: {
    path: ICON_PATH.Place,
    anchor: { x: 12, y: 22 },
    fillColor: "#3EB077",
    fillOpacity: 1,
    strokeColor: "#1A8A4C",
    strokeOpacity: 1,
    scale: 1.3,
  } as google.maps.Symbol,
  RouteOrigin: {
    path: ICON_PATH.Origin,
    fillColor: "#D13F2C",
    fillOpacity: 1,
    strokeColor: "#FFFFFF",
    strokeOpacity: 1,
    strokeWeight: 4,
    scale: 0.8,
  } as google.maps.Symbol,
};
